document.addEventListener("DOMContentLoaded", () => {
  const filterTrigger = document.getElementById("filter-trigger");
  const filterDrawer = document.getElementById("filter-drawer");
  const filterClose = document.getElementById("filter-close");
  const categoryFilters = document.querySelectorAll(".filter-category");
  const yearFilters = document.querySelectorAll(".filter-year");
  const articles = document.querySelectorAll(".blog-post-card");
  const resetButton = document.getElementById("reset-filters-btn");

  // Function to toggle drawer
  const toggleDrawer = (open) => {
    filterDrawer.classList.toggle("active", open);
    filterTrigger.setAttribute("aria-expanded", open);
    filterDrawer.setAttribute("aria-hidden", !open);
    if (open) filterDrawer.focus();
  };

  // Open & Close Drawer
  filterTrigger.addEventListener("click", () => toggleDrawer(true));
  filterClose.addEventListener("click", () => toggleDrawer(false));

  // Close drawer with Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && filterDrawer.classList.contains("active")) {
      toggleDrawer(false);
    }
  });

  function updateFilterCounts() {
    const categoryCounts = {};
    const yearCounts = {};

    categoryFilters.forEach((checkbox) => {
      categoryCounts[checkbox.value] = 0;
    });

    yearFilters.forEach((checkbox) => {
      yearCounts[checkbox.value] = 0;
    });

    articles.forEach((article) => {
      const articleCategories = article.dataset.category.split(",");
      const articleYear = article.dataset.year;

      articleCategories.forEach((category) => {
        if (categoryCounts.hasOwnProperty(category)) {
          categoryCounts[category]++;
        }
      });

      if (yearCounts.hasOwnProperty(articleYear)) {
        yearCounts[articleYear]++;
      }
    });

    categoryFilters.forEach((checkbox) => {
      const countSpan = checkbox.parentElement.querySelector(".count");
      if (countSpan) {
        countSpan.textContent = `(${categoryCounts[checkbox.value]})`;
      }
    });

    yearFilters.forEach((checkbox) => {
      const countSpan = checkbox.parentElement.querySelector(".count");
      if (countSpan) {
        countSpan.textContent = `(${yearCounts[checkbox.value]})`;
      }
    });
  }

  function updateURL(selectedCategories, selectedYears) {
    const currentURL = new URL(window.location.href);

    if (selectedCategories.length > 0) {
      currentURL.searchParams.set("category", selectedCategories.join(","));
    } else {
      currentURL.searchParams.delete("category");
    }

    if (selectedYears.length > 0) {
      currentURL.searchParams.set("year", selectedYears.join(","));
    } else {
      currentURL.searchParams.delete("year");
    }

    window.history.replaceState({}, "", currentURL);
  }

  function filterArticles() {
    const selectedCategories = Array.from(categoryFilters)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    const selectedYears = Array.from(yearFilters)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    articles.forEach((article) => {
      const articleCategories = article.dataset.category.split(",");
      const articleYear = article.dataset.year;

      const categoryMatch =
        selectedCategories.length === 0 ||
        selectedCategories.some((category) => articleCategories.includes(category));

      const yearMatch =
        selectedYears.length === 0 || selectedYears.includes(articleYear);

      if (categoryMatch && yearMatch) {
        article.classList.add("visible");
      } else {
        article.classList.remove("visible");
      }
    });

    updateURL(selectedCategories, selectedYears);
  }

  function applyFiltersFromURL() {
    const currentURL = new URL(window.location.href);
    const selectedCategories = currentURL.searchParams.get("category")?.split(",") || [];
    const selectedYears = currentURL.searchParams.get("year")?.split(",") || [];

    categoryFilters.forEach((checkbox) => {
      checkbox.checked = selectedCategories.includes(checkbox.value);
    });

    yearFilters.forEach((checkbox) => {
      checkbox.checked = selectedYears.includes(checkbox.value);
    });

    filterArticles();
  }

  function resetFilters() {
    categoryFilters.forEach((checkbox) => (checkbox.checked = false));
    yearFilters.forEach((checkbox) => (checkbox.checked = false));

    articles.forEach((article) => {
      article.classList.add("visible");
    });

    updateURL([], []);
    updateFilterCounts();
  }

  categoryFilters.forEach((checkbox) =>
    checkbox.addEventListener("change", filterArticles)
  );

  yearFilters.forEach((checkbox) =>
    checkbox.addEventListener("change", filterArticles)
  );

  resetButton.addEventListener("click", resetFilters);

  applyFiltersFromURL();
  updateFilterCounts();

  const paginationLinks = document.querySelectorAll(".pagination__link");

  paginationLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();

      const currentParams = new URLSearchParams(window.location.search);
      const href = link.getAttribute("href");

      // Create a new URL relative to the current origin
      const destinationURL = new URL(href, window.location.origin);

      // Merge existing params in destination href
      const destinationParams = new URLSearchParams(destinationURL.search);

      // Append current page filters (if not already in destination)
      currentParams.forEach((value, key) => {
        if (!destinationParams.has(key)) {
          destinationParams.set(key, value);
        }
      });

      // Update the search in the destination URL
      destinationURL.search = destinationParams.toString();

      // Redirect to the final URL
      window.location.href = destinationURL.toString();
    });
  });
});

